class ComparisonToggle extends HTMLElement {
    connectedCallback() {
      this.toggleElements = this.querySelectorAll('[data-toggle-description]');
      this.initToggle();
      this.openFirstItem();
    }

    initToggle() {
      this.toggleElements.forEach((element) => {
        element.addEventListener('click', () => {
          const comparisonItem = element.closest('.comparison-item');
          comparisonItem.classList.toggle('active');
        });
      });
    }

    openFirstItem() {
      const firstItem = this.querySelector('.comparison-item');
      if (firstItem) {
        firstItem.classList.add('active');
      }
    }
  }

  customElements.define('comparison-toggle', ComparisonToggle);